import React, { useMemo, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import SubmitButton from '../../../formComponents/SubmitButton';
import { functions } from '../../../../../firebase-client';

const safeConfirm = (message) => (
  typeof window !== 'undefined' ? window.confirm(message) : false
);

function friendlyCancellationError(error) {
  const message = typeof error?.message === 'string' ? error.message : '';
  if (message.includes('Refund or resolve all active tickets')) return message;
  if (error?.code === 'functions/permission-denied') return 'You do not have permission to cancel events.';
  return 'The event could not be cancelled. Please try again.';
}

export default function CancelEventSection({
  teamId,
  eventId,
  occurrenceId = '',
  isRecurring = false,
  occurrenceScope = false,
  onCancelled,
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const cancelEvent = useMemo(() => httpsCallable(functions, 'cancelEventScope'), []);
  const scope = occurrenceScope ? 'occurrence' : isRecurring ? 'series' : 'event';
  const subject = occurrenceScope ? 'this occurrence' : isRecurring ? 'this entire series' : 'this event';

  const handleCancel = async () => {
    if (!safeConfirm(`Cancel ${subject}? Active tickets covering it must be refunded first.`)) return;
    setBusy(true);
    setError('');
    try {
      await cancelEvent({ teamId, eventId, scope, occurrenceId: occurrenceScope ? occurrenceId : undefined });
      onCancelled?.();
    } catch (err) {
      setError(friendlyCancellationError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="card" style={{ marginTop: 16 }} aria-labelledby="cancel-event-title">
      <div className="card-header">
        <h3 id="cancel-event-title" style={{ margin: 0 }}>
          {occurrenceScope ? 'Cancel occurrence' : isRecurring ? 'Cancel series' : 'Cancel event'}
        </h3>
      </div>
      <div className="card-body" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: '1 1 240px' }}>
          Cancelling hides {subject} from calendars and stops new ticket sales. Existing active tickets must be refunded first.
          {error ? <div role="alert" style={{ color: '#b91c1c', marginTop: 8 }}>{error}</div> : null}
        </div>
        <SubmitButton
          type="button"
          variant="danger"
          label={busy ? 'Cancelling…' : occurrenceScope ? 'Cancel occurrence' : isRecurring ? 'Cancel series' : 'Cancel event'}
          onClick={handleCancel}
          disabled={busy}
        />
      </div>
    </section>
  );
}
